import { getVueTemplate } from "../../_imports/utils/utils.common";
import FormsField from "./forms-field.vue";

export default {
    name: 'forms-fieldset',
    template: getVueTemplate('forms-fieldset'),
    components: {
        FormsField
    },
    props: {
        field: Object
    },
    data() {
        return {
            connectedFields: [],
            visibleFields: []
        }
    },
    computed: {
        fields() {
            return this.field.fields;
        }
    },
    methods: {
        onInnerFieldStateUpdate() {
            this.revalidateFieldStatuses();
        },
        revalidateFieldStatuses() {
            const connectedFields = [];
            const visibleFields = [];

            this.$nextTick(() => {
                if (this.fields
                    && this.fields.length) {
                        this.fields.forEach(field => {
                            if (!field.state) {
                                return;
                            }

                            if ('connected' in field.state
                                && field.state.connected) {
                                connectedFields.push(field);
                            }

                            if (!('isVisible' in field.state)
                                || field.state.isVisible) {
                                visibleFields.push(field);
                            }
                        });
                }
    
                this.connectedFields = connectedFields;
                this.visibleFields = visibleFields;
            });
        }
    }
};